// extracted by mini-css-extract-plugin
module.exports = {"row":"NewSeller_row__3bAeh","col":"NewSeller_col__1n4YT","card":"NewSeller_card__1vQHB"};